import { Injectable } from "@angular/core";
import {
  Headers,
  Http,
  RequestOptions,
  ResponseContentType,
} from "@angular/http";
import { ConnectionService } from "./connection.service";
import { Observable } from "rxjs";
import { AppFile } from "../entities/AppFile";
import { AppConfig } from "../app.config";

@Injectable()
export class FileService {
  apiUrl: string;

  get headers(): Headers {
    return this.connectionService.GetAuthorizationHeader();
  }
  constructor(
    private http: Http,
    private connectionService: ConnectionService,
    private config: AppConfig
  ) {
    this.apiUrl = config.getConfig("endPointApiUrl") + "api/Files/";
  }

  getFilesByKey(
    key: string,
    type: string,
    companyReference: string = null
  ): Observable<AppFile[]> {
    let url = this.apiUrl + `getFilesByKey/{${key}}/${type}`;

    return this.http
      .get(url, {
        headers:
          this.connectionService.GetAuthorizationHeader(companyReference),
      })
      .map((response) => response.json() as AppFile[]);
  }

  uploadFiles(
    files: AppFile[],
    companyReference: string = ""
  ): Observable<any> {
    var fileOptions = new RequestOptions();
    fileOptions.headers =
      this.connectionService.GetFileWithBoundaryAuthorizationHeader(
        companyReference
      );

    const formData = new FormData();
    for (var file of files) {
      file.Key = "{" + file.Key + "}";
    }
    // Append files to the virtual form.
    for (const file of files) {
      formData.append(file.FileName, JSON.stringify(file));
    }
    const resp = this.http
      .post(this.apiUrl + "UploadLargeFiles", formData, fileOptions)
      .catch((err) => {
        throw err;
      });
    return resp;
  }

  downloadFile(
    no: number,
    companyReference: string = null,
    fileExtension: string = null
  ): Observable<Blob> {
    let url = this.apiUrl + "downloadFile/" + no;

    if (fileExtension) {
      url += "/" + fileExtension;
    }

    return this.http
      .get(url, {
        headers:
          this.connectionService.GetAuthorizationHeader(companyReference),
        responseType: ResponseContentType.Blob,
      })
      .map((response) => response.blob() as Blob);
  }
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/services/file.service.ts